/** Format MapLibre's fractional zoom as the quiet whole-level readout.
 *  Spelled out ("zoom 17") rather than the terse "z17" — #100: the readout
 *  means nothing to a sailor as jargon. */
export function formatZoom(zoom: number): string {
  return `zoom ${Math.round(zoom)}`;
}
